import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltungen-benutzerverwaltung-rolle-berechtigungen-setzen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungenBenutzerverwaltungRolleBerechtigungenSetzenEffects {

    VeranstaltungenBenutzerverwaltungRolleBerechtigungenSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNGEN_BENUTZERVERWALTUNG_ROLLE_BERECHTIGUNGEN_SETZEN),
        mergeMap((x: ac.PostVeranstaltungenBenutzerverwaltungRolleBerechtigungenSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungenBenutzerverwaltungRolleBerechtigungenSetzen(x.veranstaltungBenutzerverwaltungRolleBerechtigungenRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungenBenutzerverwaltungRolleBerechtigungenSetzenErfolgreichAction(result, x.veranstaltungBenutzerverwaltungRolleBerechtigungenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungenBenutzerverwaltungRolleBerechtigungenSetzenFehlerAction(error, x.veranstaltungBenutzerverwaltungRolleBerechtigungenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerVerwaltungExtensionCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerVerwaltungExtensionCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerVerwaltungExtensionCommandService);
        }
        return this.service;
    }
}
